import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IEmailData } from "common/records/Email";

export const RECEIVE_EMAILS = "@emails/RECEIVE_EMAILS";
export const RECEIVE_EMAIL = "@emails/RECEIVE_EMAIL";

export const EmailActions = {
  receiveEmails: (emails: Partial<IEmailData>[]) => createAction(RECEIVE_EMAILS, { emails }),
  receiveEmail: (email: Partial<IEmailData>) => createAction(RECEIVE_EMAIL, { email }),
};

export type EmailActions = ActionsUnion<typeof EmailActions>;
